import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { SubjectTaskDatabase } from "../../../types";
import { keys } from "./keys";
import { _3_DAYS } from "../../../constants/durations";

async function fetchSubjectTasks(subTopicId: string, state: 'pending' | 'completed' | null) {
  let query = apiClient
    .from('subject_tasks')
    .select('*')
    .eq('subject_id', subTopicId)
    .order('position', { ascending: true });

  if (state) {
    query = query.eq('state', state);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return data as SubjectTaskDatabase[];
}

export function useGetSubjectTasksBySubTopicId(subTopicId: string | undefined, state: 'pending' | 'completed' | null) {
  return useQuery({
    queryKey: keys.getSubjectTasksFiltered(subTopicId ?? '', state),
    queryFn: () => fetchSubjectTasks(subTopicId!, state),
    enabled: !!subTopicId,
    staleTime: _3_DAYS
  });
}
